import { ref } from 'vue'

const isContextSet = ref(false)

export function useDatadog() {
  return {
    isContextSet,
  }
}
